export default __webpack_public_path__ + "images/process_7.svg?3dff1d60fdd1894f1662b6fbf10b763f";